var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "base-select",
    {
      attrs: {
        error: _vm.errorText,
        loading: _vm.loading,
        label: "UF",
        id: "states"
      },
      model: {
        value: _vm.state,
        callback: function($$v) {
          _vm.state = $$v
        },
        expression: "state"
      }
    },
    [
      _c("option", { attrs: { value: "0", disabled: "", selected: "" } }),
      _vm._v(" "),
      _vm._l(_vm.states, function(state, index) {
        return _c("option", { key: index, domProps: { value: state.id } }, [
          _vm._v(_vm._s(state.sigla) + " - " + _vm._s(state.nome))
        ])
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-388f5a2f", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-388f5a2f","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/_Shared/IBGE/States.vue
// module id = null
// module chunks = 